import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Save grid configuration")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Reset grid")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeChart = _resolveComponent("TreeChart")!
  const _component_router_wrapper_component = _resolveComponent("router-wrapper-component")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_wrapper_component, null, {
            default: _withCtx(({ pushRoute }) => [
              _createVNode(_component_TreeChart, {
                dataSet: _ctx.getGrid,
                onNodesToggled: _ctx.handleNodesToggledEvent,
                onView: ($event: any) => (pushRoute($event.objectId, $event.componentName))
              }, null, 8, ["dataSet", "onNodesToggled", "onView"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, { onClick: _ctx.onSubmit }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ion_button, {
            onClick: _ctx.resetGrid,
            color: "warning"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}